import { IManifestoOptions, Resource } from "./internal";

export class Thumbnail extends Resource {
  constructor(jsonld: any, options: IManifestoOptions) {
    super(jsonld, options);
  }
}
